import { useEffect } from "react";

export default function useComponentDidMount(onMount) {
  useEffect(onMount, []);
}
